import { atom } from 'recoil';

import { Atoms } from '@store/constants';

export type BulkWorkspaceCreationProgressItem = {
  name: string;
  progressPercentage: number;
};

export const bulkWorkspaceCreationProgressAtom = atom({
  key: Atoms.bulkWorkspaceCreationProgress,
  default: [] as BulkWorkspaceCreationProgressItem[],
});
